// extracted by mini-css-extract-plugin
export default {"wrapper":"Dr-z","response":"Er-z","error":"Fr-z","disabled":"Gr-z","buttons":"Hr-z","feedbackQuestionSection":"Ir-z","yesNoWrapper":"Jr-z"};